module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-07.f17f7830.jpg";